import React from 'react';
import PropTypes from 'prop-types';
import keygen from '~helpers/keygen';
import { cleanHTML } from '../../../../../helpers/strings';
import styles from './template-three.module.scss';
import Item from './item';

export default function TemplateOne({
  module,
  readMore = true,
  scrollableContent = false,
  characterMaxReadMore = 600,
  buttonType = 'secondary',
  buttonSize = 'm',
  width = 104,
  height = 104,
  modulePosition
}) {
  const { items } = module;
  return (
    <div className={styles?.spotlightsImage || ''}>
      {
        // eslint-disable-next-line react/prop-types
        items?.map((res) => {
          // if text is shorter no need to show the button
          const plainText = cleanHTML(res?.text || "");
          
          const readMoreCheck = plainText.length > characterMaxReadMore;
          return (
            <Item 
              key={keygen()}
              item={res}
              readMore={readMoreCheck ? readMore : false}
              scrollableContent={scrollableContent}
              buttonType={buttonType}
              buttonSize={buttonSize}
              width={width}
              height={height}
              modulePosition={modulePosition} 
              moduleName={module.name}
            />
          );
        })
      }
    </div>
  );
}

TemplateOne.propTypes = {
  module: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
    name: PropTypes.string,
  }).isRequired,
  readMore: PropTypes.bool,
  scrollableContent: PropTypes.bool,
  characterMaxReadMore: PropTypes.number,
  buttonType: PropTypes.string,
  buttonSize: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  modulePosition: PropTypes.number,
};
